// test321
(321 && 0);
